export function extractFileName(fullUrl: string) {
    const regexp = new RegExp('(?:.+\/)([^#?]+)');
    return fullUrl.match(/(?:.+\/)([^#?]+)/)[1];
}



// WEBPACK FOOTER //
// ./src/app/shared/helpers/fileNameExtraction.ts